export default {
  // TODO
  host: globalThis.window?.location.host.slice(-3),
  isSendTelegram: false,
  isSendAdmin: false,
  TELEGRAM_TOKEN: process.env.TELEGRAM_BOT_TOKEN,
  DFA_LOGS_ID: process.env.DFA_LOGS_ID,
  LOGS_SERVER_URL: process.env.LOGS_SERVER_URL,
};
